import React from 'react'

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-first-line">
        <div className="content">

        </div>
      </div>
      <div className="footer-second-line">
        <div className="content">
          2021 &copy; Copyright Benox Sp.J.
        </div>
      </div>
    </div>
  )
}

export default Footer